import type { SavedProductType } from "@shared/types/SavedProducts";

export const formatAmountString = (savedProduct: SavedProductType): string => {
  let s = "";
  if (savedProduct.unit_quantity > 1) {
    s += savedProduct.unit_quantity + " ";
    if (savedProduct.product.container_type == "other") {
      s += "other";
    } else if (savedProduct.product.container_type == "box") {
      s += "boxes";
    } else {
      s += savedProduct.product.container_type + "s";
    }
    if (savedProduct.case_quantity > 0) {
      s += ", ";
    }
  } else if (savedProduct.unit_quantity == 1) {
    s += savedProduct.unit_quantity + " ";
    if (savedProduct.product.container_type == "other") {
      s += "other";
    } else if (savedProduct.product.container_type == "box") {
      s += "box";
    } else {
      s += savedProduct.product.container_type;
    }
    if (savedProduct.case_quantity > 0) {
      s += ", ";
    }
  }

  if (savedProduct.case_quantity) {
    if (savedProduct.case_quantity > 1) {
      s += savedProduct.case_quantity + " cases";
    } else if (savedProduct.case_quantity == 1) {
      s += savedProduct.case_quantity + " case";
    }
  }
  return s;
};


